/**
 * Types and constants shared across CouponCodes flows.
 */

import { isOfferBankFieldsEnabled } from "./flag";
import type { OfferCategory } from "@/api/offerBank";

export type DiscountType = OfferCategory;

export const DISCOUNT_TYPES: { value: DiscountType; label: string }[] = [
  { value: "percent_off", label: "% Off (Fixed Amount)" },
  { value: "dollar_off", label: "$ Off (Fixed Amount)" },
  { value: "bogo", label: "Buy X Get Y" },
  { value: "free_shipping", label: "Free Shipping" },
  { value: "other", label: "Other" },
];

/** The Discount Type options; "Other" only once the Offer Bank fields flag is on (FOG-2824). */
export function discountTypeOptions(siteId: string | undefined) {
  return isOfferBankFieldsEnabled(siteId)
    ? DISCOUNT_TYPES
    : DISCOUNT_TYPES.filter((type) => type.value !== "other");
}

/** Id of the embedded edit form; the dialog's footer Save targets it via the native `form` attribute. */
export const EDIT_OFFER_FORM_ID = "edit-offer-form";

export function slugifyDiscountName(name: string): string {
  return name.toLowerCase().replace(/ /g, "-");
}
